import * as React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useMutation } from "react-query";
import { setAuthStatus } from '../../request/Auth/authSlice';

import apiClient from '../../request/http-common';
import { setUser } from '../Auth/userSlice';
import { useDispatch } from 'react-redux';

export default function DeleteConnection({conn}) {
    
    const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
    const [error, setErros] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


    const { isLoading: isSendingRequest, mutate: postLogin } = useMutation(

        async () => {
          return await apiClient.post(`/api/delete-connection/${conn.id}`);
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
            const event = new Event('newMessage');
            window.dispatchEvent(event);

           setTimeout(() => {
            window.location.reload();
           }, 2000);
            
           
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.message) 
            const event2 = new Event('processed');
            window.dispatchEvent(event2);      
          },
        }
      );

  return (
    <React.Fragment>
      <Button color="error" variant="contained" size='small' onClick={handleClickOpen}>
        delete
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Delete Connection</DialogTitle>

        <DialogContent>
          <DialogContentText mm={4}>
            Are you sure you want to delete your connection ?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{justifyContent: 'space-between'}}>
          <Button color='info' onClick={handleClose}>Cancel</Button>
          <Button color='error' onClick={postLogin}> {isSendingRequest ? 'deleting details...' : 'delete connection'}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}